"use client";
import React from "react";

import Header from "../components/Header";
import SideBar from "../components/account/SideBar";

import { useNavigate } from "react-router-dom";
import AccountLayout from "../layout/AccountLayout";

const MySettingPage = () => {

  return (
    <>
      <AccountLayout>

        <h2>Cài đặt</h2>

        <section className="content-section">
          <h4>Lessons progress</h4>
          <p>
            Lessons progress are the check icons you can see on the
            lessons page sidebar when you completing them.
          </p>
          <p>
            You can reset them individually by clicking on those icons or
            you can reset them all using the button bellow.
          </p>

          <a
            href="https://threejs-journey.com/account/settings/reset-lessons-progress"
            className="button is-purple"
            data-router-set=""
          >
            <span className="hover"></span>
            <span className="label">Reset lessons progress</span>
          </a>
        </section>

        <section className="content-section">
          <h4>Lessons popins</h4>
          <p>
            Lessons popins are showing up when you open a lesson page.
            Clicking on <strong>Close and remember</strong> prevents this
            popin from showing up again.
          </p>
          <p>
            You can reset the popins in order to see them again using the
            button bellow.
          </p>

          <a
            href="https://threejs-journey.com/account/settings/reset-lessons-popins"
            data-router-disabled=""
            className="js-reset-lessons-popins button is-purple"
          >
            <span className="hover"></span>
            <span className="label">Reset lessons popins</span>
          </a>
        </section>

        <section className="content-section">
          <h4>Certificate / Quiz</h4>
          <p>
            You can reset your certificate and answers to the quiz by
            using the button bellow.
          </p>

          <div className="alerts">
            <div className="alert is-warning has-icon">
              <span className="icon">
                <svg
                  width="29"
                  height="27"
                  viewBox="0 0 29 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M28.1785 19.209L18.6548 2.70482C17.7966 1.21871 16.2111 0.302979 14.4947 0.302979C12.7784 0.302979 11.1928 1.21871 10.3347 2.70482L0.64363 19.4916C-0.214543 20.9777 -0.214543 22.8092 0.64363 24.2953C1.5018 25.7814 3.08733 26.6971 4.80368 26.6971H24.1859C24.1911 26.6971 24.1963 26.6971 24.1963 26.6971C26.8493 26.6971 29 24.5464 29 21.8934C29 20.8992 28.6965 19.973 28.1785 19.209ZM16.5512 20.8154C16.5512 21.9509 15.6774 22.8196 14.5 22.8196C13.3226 22.8196 12.4488 21.9509 12.4488 20.8154V20.7684C12.4488 19.638 13.3226 18.7642 14.5 18.7642C15.6774 18.7642 16.5512 19.6329 16.5512 20.7684V20.8154ZM16.5983 7.30443L15.5832 16.1688C15.5152 16.8072 15.0913 17.2048 14.5 17.2048C13.9087 17.2048 13.4848 16.8019 13.4168 16.1688L12.4017 7.2992C12.3336 6.61371 12.7052 6.09566 13.3436 6.09566H15.6512C16.2896 6.1009 16.6664 6.61894 16.5983 7.30443Z"
                    fill="#FFD78A"
                  ></path>
                </svg>
              </span>
              <p>
                This will invalidate your certificate if you've earned it
                already.
              </p>
            </div>
          </div>

          <a
            href="https://threejs-journey.com/account/settings/reset-certificate-quiz"
            data-router-disabled=""
            className="button is-purple"
            onclick="return confirm('Are you sure you want to reset your certificate and quiz answers?')"
          >
            <span className="hover"></span>
            <span className="label">Reset certificate and quiz</span>
          </a>
        </section>
      </AccountLayout>
    </>
  );
};

export default MySettingPage;
